import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from '@posthog/react';

/**
 * Captures SPA page views on route changes.
 * Must be placed inside BrowserRouter.
 */
export function PostHogPageView() {
  const posthog = usePostHog();
  const location = useLocation();

  useEffect(() => {
    if (posthog) {
      posthog.capture('$pageview');
    }
  }, [posthog, location.pathname]);

  return null;
}
